import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  () => ({
    root: {
      "& .MuiPaper-root": {
        maxWidth: 440,
        // width: "100%",
        borderRadius: 16,
        position: "relative"
      },
      "& .MuiDialogTitle-root": {
        padding: "20px 20px 0",
        textAlign: "center"
      },
      "& .MuiDialogContent-root": {
        padding: "0px 24px 0 24px",
        // height: 48,
        textAlign: "center"
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        padding: "24px 24px 32px",
        columnGap: 16,
        justifyContent: "center"
      },
      "& .MuiButton-root": {
        fontSize: "1.8rem",
        "& .MuiTypography-root": {
          fontSize: "1.8rem"
        }
      }
    },
    btnAction: {
      height: 48,
      "&.MuiButton-containedPrimary .MuiTypography-root": {
        color: "#ffffff"
      }
    },
    typeButton: {
      height: 48
    },
    typeButtonSCG: {
      marginBottom: 30
    },
    checkCircleimg: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }),
  { name: "DialogUploadFail" }
);

export default useStyles;
